import React from 'react';
import { View, Text } from '../base_components';
import Link from './link';

import { styles, getButtonStyles } from './text_button';

type Props = {
  text: string;
  url: string;
  style?: any;
  textStyle?: any;
  type?: any;
  beforeText?: any;
  afterText?: any;
  disabled?: boolean;
  onPress?: (event?: any) => any;
};
export default function LinkTextButton(props: Props) {
  const { style, textStyle, text, beforeText, afterText, onPress } = props;
  const { button_extra, text_extra } = getButtonStyles(props);

  return (
    <Link
      style={[styles.textButton, button_extra, style]}
      url={props.url}
      onPress={onPress}
    >
      <View style={styles.inner}>
        {beforeText}
        <Text style={[styles.text, text_extra, textStyle]}>{text}</Text>
        {afterText}
      </View>
    </Link>
  );
}
